import { render } from "./QrCodeView.vue?vue&type=template&id=b2c7a644&scoped=true"
import script from "./QrCodeView.vue?vue&type=script&lang=js"
export * from "./QrCodeView.vue?vue&type=script&lang=js"

import "./QrCodeView.vue?vue&type=style&index=0&id=b2c7a644&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2c7a644"]])

export default __exports__